const config = {
  REGION: "ap-southeast-2",
  BUCKET: "pg-dev-file-gateway",
  USER_POOL_ID: "ap-southeast-2_XfM5W0g66",
  USER_POOL_APP_CLIENT_ID: "37ddc8osu178er2ea4p6n797ob",
  USER_POOL_DOMAIN: "https://dev-nonprod-idp-filegateway-pg.auth.ap-southeast-2.amazoncognito.com",
  IDENTITY_POOL_ID: "ap-southeast-2:d9966fee-9635-4eeb-aa8f-534e419fa69b",
};

export default config;
